























import Vue from 'vue'
import { FrameSizeOptions } from '@/constants/figurePainting'
import PaintOptions from './PaintOptions.vue'

export default Vue.extend({
  name: 'PaintFrameSizeOptions',
  components: {
    PaintOptions
  },
  props: {
    current: {
      type: String,
      default: ''
    }
  },
  computed: {
    frameSizeOptions (): typeof FrameSizeOptions {
      return FrameSizeOptions
    },
    currentData: {
      get () {
        const { current } = this
        return current
      },
      set (value: { [key in string]: string }) {
        (this as any).$emit('update', value)
      }
    }
  },
  methods: {
    convertFrameSizeProps (size: { [key: string]: number }) {
      const { width, height } = size
      return {
        width,
        height,
        x: 15 - (width / 2),
        y: 15 - (height / 2)
      }
    }
  }
})
